import { Container, HeaderTitle, SubmitButton, InputForm } from "./style";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import { FormDataSource } from "../../util/formDataSource";
import { Left, Right } from "./style";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";

import { useAppLocation } from "../../hooks/useAppLocation";
import { addCompany, getCompany, updateCompany } from '../../api/companysService';
import { getEvents } from "../../api/eventsService";

import { toast } from 'react-toastify';

interface Props {
  Inputs: FormDataSource[];
  actionMode: string;
}
export type IUploadStatus = "NO_IMAGE" | "UPLOADING" | "UPLOADED";

const NewCompany: React.FC<Props> = ({ Inputs, actionMode }) => {
  const { id }: any = useParams();

  const [events, setEvents]: any = useState([]);

  // states
  const [file, setFile] = useState<File | null>(null);
  // upload status for disabling submit button
  const [data, setData]: any = useState({
    timestamp: new Date(),
    logo: `uploads/images/noimage.png`,
  });
  const [uploadStatus, setUploadStatus] = useState<IUploadStatus>("NO_IMAGE");

  const navigate = useNavigate();
  const location = useAppLocation();

  useEffect(() => {
    getEvents()
      .then((events: any) => setEvents(events))
      .catch((err: any) => console.log(err.message));
  }, [])
  useEffect(() => {
    // console.log(actionMode);
    if (actionMode == 'edit') {
      getCompany(id).then((item) => {
        setData(item);
      }).catch((err) => {
        console.log('error', err.message);
      })
    }
  }, [actionMode]);

  useEffect(() => {
    if (file) {
      setData({
        ...data,
        image: file.name,
        file: file
      });
      setUploadStatus("UPLOADED");
    }
  }, [file]);

  // handle form submiting
  const handleSubmit = async (e: React.FormEvent<HTMLElement>) => {
    e.preventDefault();
    // Destructure required fields from the data object
    const { name, product_service_keywords, website_social_media, first_name, last_name, primary_email, phone, description } = data;

    // Validate required fields
    if (
      !name ||
      // !product_service_keywords ||
      // !website_social_media ||
      !first_name ||
      !last_name ||
      !primary_email
      // !phone ||
      // !description
    ) {
      console.log('All fields are required.');
      // You can display an alert, set error messages, or handle this as per your UI requirements
      toast.error('All fields are required.', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    let result = null;
    try {
      if (actionMode === 'edit') {
        result = await updateCompany(data);
      } else {
        result = await addCompany(data);
      }
      navigate(-1);//'/companys'

    } catch (error: any) {
      console.log(error.message);
    }

  };

  //handle image upload
  const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
      setUploadStatus("UPLOADING");
    } else {
      setUploadStatus("NO_IMAGE");
    }
  };

  // handle form inputs
  const handleInput = (e: any) => {
    const id = e.target.id;
    const value = e.target.value;

    setData({ ...data, [id]: value });
  };

  // JSX Return
  return (
    <Layout>
      <HeaderTitle>{actionMode === 'edit' ? 'Edit Company' : 'Add New Company'}</HeaderTitle>
      <Container>
        {/* Image upload */}
        <Left>
          <img
            src={
              file
                ? URL.createObjectURL(file)
                : `${process.env.REACT_APP_SERVER_URL}/api/${data.logo}`
            }
            alt="img"
            className="img"
          />
        </Left>
        <Right>
          {/* Input form */}
          <InputForm
            onSubmit={(e: any) => handleSubmit(e)}
          >
            <div className="file">
              <p className="inputTitle">Upload Logo:</p>
              <label htmlFor="file">
                <DriveFolderUploadIcon className="icon" />
              </label>
            </div>
            <input
              onChange={handleFile}
              name="img"
              style={{ display: "none" }}
              type="file"
              id="file"
            />
            {/* Generating inputs from JSON */}
            {Inputs.map((input) => (
              <div key={input.id} className="input">
                <label className="inputTitle">{input.label}</label>
                <br />
                <input
                  onChange={handleInput}
                  id={input.id}
                  className="inputField"
                  type={input.type}
                  placeholder={input.placeholder}
                  value={data[input.id]}
                />
              </div>
            ))}
            {/* <div className="input">
              <label htmlFor="event_id" className="inputTitle">Event</label>
              <br />
              <select id="event_id" className="inputField" value={data.event_id} onChange={handleInput}>
                <option value="-1">Select Event</option>
                {
                  events.map((item: any) => {
                    return (<option key={item.id} value={item.id}>{item.title}</option>)
                  })
                }
              </select>
            </div> */}
            {/* <div key={'blank'} className="input">
              <label className="inputTitle"></label>
              <br />
              <input
                className="inputField"
                disabled
              />
            </div> */}
            <div className="full-width">
              <label className="inputTitle">{"Description"}</label>
              <br />
              <textarea
                onChange={handleInput}
                id={'description'}
                className="descriptionField"
                placeholder={"Company Description (max 50 words)"}
                value={data['description']}
                rows={5}
              />
            </div>
            {uploadStatus === "UPLOADING" ? (
              <SubmitButton disabled type="submit">
                Uploading...
              </SubmitButton>
            ) : (
              <SubmitButton type="submit">SUBMIT</SubmitButton>
            )}
          </InputForm>
        </Right>
      </Container>
    </Layout>
  );
};

export default NewCompany;
